export default __webpack_public_path__ + "images/2786bcade18158c2c5511f42f7badab6.png";